'use client'

export default function LandingBlockPlatforms(props: any) {
    return (
        <div style={{maxWidth: 600}} className={"px-4 lg:px-0"}>
            <div className={"text-xl mb-7 font-light"}>
                <span className={"text-4xl font-semibold"}>How can I get it? 🧐</span>
                <div>
                    <div className={"border-b border-b-fuchsia-300 w-10 md:w-20 lg:w-96 my-7"}></div>
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                The Bullish Trade is available for any platform.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                You can download it for <span className={"font-bold"}>Windows</span>, <span className={"font-bold"}>Mac</span>, and <span className={"font-bold"}>Linux</span>.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                If you also need to check the markets on the go, we have <span className={"font-bold"}>mobile apps</span> for iOS and Android.
            </div>

            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                {"If you don't want to download anything yet, you can use our "}<span className={"font-bold"}>web app</span>, right in your browser.
            </div>

            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Download The Bullish Trade App: <a className={"border-b hover:border-b-2"} href={"/downloads"}>All downloads</a>
            </div>
        </div>
    )
}
